import { render } from "./Imprint.vue?vue&type=template&id=1b986c5e&scoped=true"
import script from "./Imprint.vue?vue&type=script&lang=js"
export * from "./Imprint.vue?vue&type=script&lang=js"

import "./Imprint.vue?vue&type=style&index=0&id=1b986c5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b986c5e"]])

export default __exports__